<template>
  <div class="banner-logo">
    <div class="line">WE STAND</div>
    <div class="line">AGAINST</div>
    <div class="underline"></div>
    <div class="line last">THE COUP</div>
  </div>
</template>

<script>
export default {
  name: "BannerLogo",
};
</script>

<style>
.banner-logo > .line {
  position: relative;
  font-size: 2em;
  font-family: "Lato";
  font-weight: 900;
  text-align: center;
  line-height: 1.1em;
  color:#ffe500;
  z-index: 3;
}


.banner-logo > .last{
  position: relative;
  top: -2vh;
}

.banner-logo {
  position: relative;
  top: 15vh;
  left: 12vw;
}

.underline {
  position: relative;
  z-index: 2;
  width: 38.5vw;
  top: -1.75vh;
  left: 30vw;
  height: 12px;
  background: black;
}
</style>